export enum EventModDescriptionEnum {
  WEJSCIE = 'events.current.list.mod.enter',
  WYJSCIE = 'events.current.list.mod.exit',
}
